
import React, { createContext, useContext, useState, useEffect } from 'react'

const DarkModeContext = createContext(true)

export function useDarkMode() {
  return useContext(DarkModeContext)
}

/**
 * Shared dark-mode context — one MutationObserver for the entire canvas tree.
 *
 * Nodes that need programmatic (non-Tailwind) dark-mode awareness should call
 * `useDarkMode()` instead of creating per-instance MutationObservers.
 */
export function DarkModeProvider({ children }: { children: React.ReactNode }) {
  const [isDark, setIsDark] = useState(true)

  useEffect(() => {
    const check = () => {
      setIsDark(document.documentElement.classList.contains('dark'))
    }
    check()
    const observer = new MutationObserver(check)
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    return () => observer.disconnect()
  }, [])

  return (
    <DarkModeContext.Provider value={isDark}>
      {children}
    </DarkModeContext.Provider>
  )
}
